import { Col, Text } from 'components';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const Paragraph = (props) => <Text marg="39px 0 0" {...props} />;

const ChildSafetyStandard = ({}) => {
  const { isMobile } = useSelector((state) => state.appState);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Col wid="100vw" center>
      <Col noFlex wid={isMobile ? 'calc(100vw - 32px)' : '1140px'} center>
        <Paragraph h1 wid="100%" center>
          Policy on Child Sexual Abuse and Exploitation (CSAE)
        </Paragraph>

        <Text h2 marg="34px 0 0">
          Purpose and Scope
        </Text>

        <Paragraph marg="15px 0 0">
          Playaz4Playaz strictly prohibits and is committed to fighting against any form of child
          sexual abuse and exploitation. We are committed to preventing, detecting, and reporting
          all instances of CSAE, including child sexual abuse material (CSAM). We adhere to all the
          policies set forth by local authorities and international regulatory frameworks.
        </Paragraph>

        <Paragraph marg="15px 0 0">
          Content, activity, or interactions that endanger, involve, or support the sexual
          exploitation of children are prohibited. This includes but is not limited to predatory
          behavior towards children, such as:
        </Paragraph>

        <ul>
          <li>
            <Paragraph marg="15px 0 0">
              Inappropriate interaction targeted at a child (for example, groping or caressing).
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Child grooming (for example, befriending a child online to facilitate, either online
              or offline, sexual contact and/or exchanging sexual imagery with that child).
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Sexualization of a minor (for example, imagery that depicts, encourages or promotes
              the sexual abuse of children or the portrayal of children in a manner that could
              result in the sexual exploitation of children).
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Sextortion (for example, threatening or blackmailing a child by using real or alleged
              access to a child’s intimate images).
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Trafficking of a child (for example, advertising or solicitation of a child for
              commercial sexual exploitation).
            </Paragraph>
          </li>
        </ul>

        <Text h2 marg="10px 0 0">
          Immediate Response Protocol
        </Text>

        <Paragraph marg="15px 0 0">
          All reports or discoveries of CSAE will be treated with the highest priority and urgency.
          Upon receiving any report of CSAE:
        </Paragraph>

        <ol>
          <li>
            <Paragraph marg="15px 0 0">
              Our dedicated safety team will immediately review and assess the report
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              All identified CSAE content will be immediately removed and preserved as evidence
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              We will promptly report all instances to relevant law enforcement agencies and
              national authorities
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Associated accounts will be immediately suspended pending investigation
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              All evidence will be securely preserved according to legal requirements
            </Paragraph>
          </li>
        </ol>

        <Text h2 marg="10px 0 0">
          Reporting Mechanisms
        </Text>

        <Paragraph marg="15px 0 0">We provide multiple channels for reporting CSAE:</Paragraph>

        <ol>
          <li>
            <Paragraph marg="15px 0 0">
              In-App Reporting: Users can report concerning content directly through our platform's
              reporting functionality.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Direct Email: Reports can be sent to{' '}
              <a href="mailto:francis.mateo@playaz4playaz.com">
                <i>francis.mateo@playaz4playaz.com</i>
              </a>
              .
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">All reports will receive priority review.</Paragraph>
          </li>
        </ol>

        <Text h2 marg="10px 0 0">
          Prevention Measures
        </Text>

        <Paragraph marg="15px 0 0">We implement robust preventive measures including:</Paragraph>

        <ol>
          <li>
            <Paragraph marg="15px 0 0">Regular platform monitoring.</Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">Proactive content moderation.</Paragraph>
          </li>
        </ol>

        <Text h2 marg="10px 0 0">
          Compliance and Legal Framework
        </Text>

        <Paragraph marg="15px 0 0">This policy operates within and adheres to:</Paragraph>

        <ol>
          <li>
            <Paragraph marg="15px 0 0">
              All applicable national and international laws regarding CSAE.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              The United Nations Convention on the Rights of the Child (UNCRC).
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">Requirements of the U.S. PROTECT Act.</Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">Mandatory reporting obligations.</Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">Data retention requirements for evidence.</Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">Privacy and child protection regulations.</Paragraph>
          </li>
        </ol>

        <Text h2 marg="10px 0 0">
          Policy Review and Updates
        </Text>

        <Paragraph marg="15px 0 0">
          This policy will be reviewed and updated as needed to ensure alignment with current laws,
          technologies, and best practices in child protection.
        </Paragraph>

        <Text h2 marg="15px 0 0">
          Contact Information
        </Text>

        <Paragraph marg="15px 0 0">
          For any questions about this policy or to report concerns:
        </Paragraph>

        <ul>
          <li>
            <Paragraph marg="15px 0 0">
              Email:{' '}
              <a href="mailto:francis.mateo@playaz4playaz.com">
                <i>francis.mateo@playaz4playaz.com</i>
              </a>
              .
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">In-app Report button</Paragraph>
          </li>
        </ul>

        <Text h2 marg="15px 0 0">
          Effective Date
        </Text>

        <Paragraph marg="15px 0 0">
          This policy is effective immediately upon publication and supersedes any previous related
          policies.
        </Paragraph>

        <Paragraph marg="30px 0 200px">Last updated: March 1, 2025</Paragraph>
      </Col>
    </Col>
  );
};

export default ChildSafetyStandard;
